import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsUserCustomObjectTypeRelationships = "/data_objects/user_data_object_type_relationships";

export const customObjectsUserCustomObjectTypeRelationshipsCacheKeys: AllRouteEndpoints[] = [
  "/data_objects/user_data_object_type_relationships",
];
